
import Vue from "vue";
import { AxiosEventEmitter } from "@/utils/axios";
import { HttpError } from "./utils/services/http-error";
import AppMotd from "@/components/Motd.vue";
import {AuthService} from "@/services/auth-service";
import { MainSocketService } from "./services";
import AppInitDossierProgress from "@/views/InitDossierProgress.vue";

export default Vue.extend({
	data(){
		return {
			initingDossierData: null as null | {progress:number, message:string}
		};
	},
	mounted() {
		AxiosEventEmitter.on("error", (err: HttpError) => {
			requestAnimationFrame(() => {
				if (err.dontShow) return;
				if (err.key) {
					if (err.key == "UNSPECIFIED") {
						console.error(err.message);
						if (err.message == "Unkown error: Sending emails without an SMTP server is disabled for DEMO accounts."){
							this.$wf.notify(this.$ct("errors.FEATURE_NOT_AVAILABLE_IN_DEMO"), "danger", 3000, "exclamation-triangle");
							err.dontShow = true;
						}
					}else{
						this.$wf.notify(err.getText(), "danger", 3000, "exclamation-triangle");
					}

					if (err.key == "SES_LIMIT_EXCEEDED"){
						this.$wf.dialog(this.$ct("common.ses-limit-reached-info"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
					}
				}
			});
		});
		MainSocketService.on("/init/dossier/progress", (progress:number, phase:string)=>{
			this.initingDossierData = {progress, message: phase};
		});
		MainSocketService.on("/init/dossier/done", ()=>{
			this.initingDossierData = null;
		});
		AuthService.mainVueInstance = this;
	},
	components: {
		AppMotd,
		AppInitDossierProgress
	}
});
